module.exports = __webpack_public_path__ + "static/img/C4D0001.0c2af80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0001.jpg
// module id = TLtg
// module chunks = 0